import React from 'react'
import { useTheme } from '@opallabs/hooks'
import { CaptionProps } from '../types'
import { styles } from './styles'

export { type CaptionProps as CaptionTextProps }

export const CaptionText: React.FC<React.PropsWithChildren<CaptionProps>> = ({
  children,
  color = null,
  theme: propTheme,
}) => {
  const providedTheme = useTheme()
  const theme = propTheme ?? providedTheme

  return <span css={styles(theme, color)}>{children}</span>
}
CaptionText.displayName = 'Lapidary: CaptionText'
